import * as yup from 'yup';

export const inputModalFormValidation = yup.object({
  value: yup.string().required(),
});

export type InputModalFormValues = yup.InferType<typeof inputModalFormValidation>;

export const DEFAULT_INPUT_VALUES: InputModalFormValues = {
  value: '',
};
